import { AxiosRequestConfig } from "axios";

/**
 * Simple function to format and log axios request config to console.
 *
 * @export
 * @param {(AxiosRequestConfig | RequiredAxiosRequestConfig)} axiosConfig
 */
export default function logHttpRequest(axiosConfig: AxiosRequestConfig): void {
  const { url, method } = axiosConfig;
  console.log(
    `Request: ${(method || "UNKNOWN").toUpperCase()} ${url || "unknown_url"}`
  );
}
